import { render, staticRenderFns } from "./DisplayOne.vue?vue&type=template&id=d35d5ee4&scoped=true"
import script from "./DisplayOne.vue?vue&type=script&lang=js"
export * from "./DisplayOne.vue?vue&type=script&lang=js"
import style0 from "./DisplayOne.vue?vue&type=style&index=0&id=d35d5ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d5ee4",
  null
  
)

export default component.exports